<div class="row">
  <div class="col-md-6">

    <div class="form-group row">
      <label for="adviserName" class="col-sm-4 col-form-label">Adviser</label>
      <div class="col-sm-8">
        <input type="text" class="form-control form-control-sm" id="adviserName" placeholder="Adviser Name" [(ngModel)]="formData.adviser">
      </div>
    </div>

    <div class="form-group row">
      <label for="numberOfCreditors" class="col-sm-4 col-form-label">Number of Creditors</label>
      <div class="col-sm-8">
        <input type="number" class="form-control form-control-sm" id="numberOfCreditors" placeholder="Number of Creditors" [(ngModel)]="formData.numberOfCreditors" (blur)="numberOfCreditorsChanged()">
      </div>
    </div>

  </div>
  <div class="col-md-6">

    <div class="form-group row">
      <label for="introducerReference" class="col-sm-4 col-form-label">Introducer Reference<sup class="text-danger">*</sup></label>
      <div class="col-sm-8">
        <input type="text" class="form-control form-control-sm" id="introducerReference" placeholder="Introducer Reference" [(ngModel)]="formData.reference" required>
      </div>
    </div>

    <div class="form-group row">
      <label for="disposableIncome" class="col-sm-4 col-form-label">
        Disposable Income<sup class="text-danger">*</sup>
      </label>
      <div class="col-sm-8">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroupPrepend">&pound;</span>
          </div>
          <input type="number" class="form-control form-control-sm" id="disposableIncome" placeholder="Disposable Income" [(ngModel)]="formData.di" required min="1">
        </div>
      </div>
    </div>

  </div>
</div>



// WEBPACK FOOTER //
// /home/runner/work/debtpanel-portal/debtpanel-portal/webforms/legal-aid/src/app/basic-details/app-basic-details.component.html